import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import { POINT_LOG_TYPE_TEXT } from '../../../../../constants/service/app/pointConstants';
import { setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';

/**
 *  포인트 Log 칼럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'내역 종류'} />,
      dataIndex: 'type',
      render: (value) => POINT_LOG_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'적립/사용처'} />,
      dataIndex: 'causeName',
    },
    {
      title: <TableColumnTitle title={'액수'} />,
      dataIndex: 'amount',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'생성시간'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
